import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { compose } from 'recompose';
import InfoIcon from '@material-ui/icons/Info';

import { ValidatedSelect, ValidatedTextField } from 'components';
import {
  withClientLocations,
  withClientDepartments,
  IWithClientLocations,
  IWithClientDepartments,
} from 'providers/queries';

interface IPropsEnhanced extends IWithClientLocations, IWithClientDepartments {}

const enhancers = compose<IPropsEnhanced, {}>(withClientLocations, withClientDepartments);

const Details: FC<IPropsEnhanced> = ({ clientLocations, clientDepartments }) => {
  const { t } = useTranslation();

  function renderDepartments() {
    const { client_departments } = clientDepartments;

    if (!client_departments.length) {
      return null;
    }

    return (
      <Grid item xs>
        <ValidatedSelect
          persistLabel
          margin="none"
          name="department_id"
          i18nKey="user:department"
          items={client_departments}
        />
      </Grid>
    );
  }

  function renderLocations() {
    const { client_locations } = clientLocations;

    if (!client_locations.length) {
      return null;
    }

    return (
      <Grid item xs>
        <ValidatedSelect
          persistLabel
          margin="none"
          name="location_id"
          i18nKey="user:location"
          items={client_locations}
        />
      </Grid>
    );
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <InfoIcon color="action" />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2">{t('common:detail_plural')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <Grid container spacing={5}>
          <Grid item xs>
            <ValidatedTextField
              TextFieldProps={{ margin: 'none' }}
              persistLabel
              name="full_name"
              i18nKey="user:fullName"
            />
          </Grid>
          <Grid item xs>
            <ValidatedTextField
              TextFieldProps={{ margin: 'none' }}
              persistLabel
              name="job_title"
              i18nKey="user:title"
            />
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          {renderDepartments()}
          {renderLocations()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default enhancers(Details);
